import React from 'react';
import { useLocation, Redirect, BrowserRouter as Router } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import apiManager from '../../../src/ApiManager';
import LoadingIndicator from '../../components/LoadingIndicator';
import TagManager from 'react-gtm-module';
import { USE_LOCAL } from '../../constants';

// hollywood
import axios from 'axios';

const styles = (theme) => ({
  root: {
    padding: '16px',
  },
});

export class SubscriptionSuccess extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this._logoutTimerID = null;
    this._logoutIntervalID = null;

    const { user, updateUser } = this.props;
    this.state = {
      user,
      updateUser,
      stripeId: '',
      stripeUser: '',
      redirect: false,
      redirectTo: '/',
      isLoading: true
    };
  }

  componentDidMount = async () => {
    // Get Query Strings returned from Stripe
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let id = params.get('id');
    let user = params.get('user');
    this.setState({ stripeId: id, stripeUser: user });

    // Get Current User Auth Session
    const authSession = await apiManager.currentSession();

    if (authSession && authSession.accessToken) {
      const token = authSession.accessToken.jwtToken;

      // Successful
      // Compare the user and Auth Session's user token
      // to prevent spoofed subscription signups
      if (token === user) {
  
        // Update users_cognito db with subscription info.
        // Normally we'd do this in the "checkout.session.completed" webhook, 
        // but the webhook lambda is outside the VPC - what a pain in the a**
        // const currentUser = localStorage.getItem('user');
        const checkoutSession = await apiManager.getCheckoutSession(id);
        console.log('checout session id: ', id);
        console.log('checkout session retrieved: ', checkoutSession);
        if (checkoutSession && checkoutSession.id) {
          const stripeUpdate = await apiManager.createUserSubscription(checkoutSession); // currentUser.email
        }

        // NOTE: Cognito check below to be deprecated when all user subs are converted
        // to users_cognito records in the front-end. 
        // There will need to be a migration process for all users somewhere between 4/15/21 and 7/2/21.

        // =====================================================
        // Wait for Cognito to be updated by 
        // Stripe 'checkout.session.completed' event
        let retries = 1;
        let subStatus = {};

        // repeat with the interval of 3 seconds
        let checkSubStatus = setInterval(async () => {
          // console.log(`Checking sub status: ${retries}`);
          
          subStatus = await apiManager.currentAttributes();
          // console.log('subStatus: ', subStatus);

          // Check if subscription status is 'true' or 10 retries (30 seconds) has been attempted
          if((subStatus && subStatus['custom:isSubscribed'] === 'true') || retries === 10) {

            // Only use in live environment
            if(!USE_LOCAL) {
              // Prepare GTM Event that a conversion occured
              const args = {
                dataLayer: {
                  event: "regenag101_sign_up",
                  referral: localStorage.getItem('referrerURL')
                  /* can pass more variables here if needed */
                }
              };

              // Fire!
              TagManager.dataLayer(args);
            }

            clearInterval(checkSubStatus);
            // Set redirect to home-page
            this.setState({ redirectTo: '/' }); // /subscription
            this.setState({ redirect: true });
          }

          // One more time
          retries++;
        }, 3000);        
      }
    }

    
  };

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectTo} />;
    }
  };

  render() {
    const { classes } = this.props;
    const { user, updateUser } = this.state;
    return (
      <div className={classes.root}>
        <Grid container spacing={4}>
          <Grid item lg={12}>
            <div style={{ margin: 250, textAlign: 'center' }}>
            <h2>Just a moment. Your subscription status is being updated...</h2>
            <p style={{margin: 24}}>Do not refresh your browser.</p>
            <LoadingIndicator/>
            {this.renderRedirect()}
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

SubscriptionSuccess.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  updateUser: PropTypes.func,
};

export default withStyles(styles)(SubscriptionSuccess);
